import script from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=25459ff7&lang=scss"

const __exports__ = script;

export default __exports__